import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackSendMessageClick } from './tracking';
import { openNewbuildingChat, openNewbuildingChatAfterAuth } from '../../actions/chat';
import { getNewbuildingInformation } from '../../selectors/newbuildingHeader';
import { getUser } from '../../selectors/user';
import { INewbuilding } from '../../types/newbuildingHeader';
import { callAuthenticationPopup } from '../../utils/authentication';

export const NewbuildingHeaderChatButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const user = useSelector(getUser);
  const newbuilding = useSelector(getNewbuildingInformation);

  const handleClick = React.useCallback(() => {
    trackSendMessageClick(newbuilding?.id);

    // Если удалось кликнуть в сниппете, то информация по сниппету ЖК есть.
    const payload = newbuilding as INewbuilding;

    if (!user.isAuthenticated) {
      dispatch(openNewbuildingChatAfterAuth(payload));
      callAuthenticationPopup();

      return;
    }

    dispatch(openNewbuildingChat(payload));
  }, [dispatch, user, newbuilding]);

  return (
    <Button onClick={handleClick} size="M" theme="fill_secondary" type="button">
      Написать застройщику
    </Button>
  );
};
